export const API_URL = "https://www.sanabreze.com/api" as string;
